export default "https://assets.egbcdn.net/assets/packs/_/images/deposit/deposit-history-5e60d930c2feeddba8d012ba98181d7a.svg";